import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const WordWrapEllipse = ({
  MaxWidth = '25ch',
  Text = '',
  isLeft = true,
  Top = '0',
  showTooltip = true,
}) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      // Check if the text overflows the max width
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    }
  }, [Text, MaxWidth]);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (isOverflowing && isHovered && textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.top + window.scrollY,
        left: isLeft ? rect.right + 8 + window.scrollX : rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOverflowing, isHovered, isLeft, Text, MaxWidth]);

  return (
    <div
      className="w-fit"
      style={{ position: 'relative', display: 'inline-block' }}
      {...(showTooltip
        ? {
            onMouseEnter: () => setIsHovered(true),
            onMouseLeave: () => setIsHovered(false),
          }
        : {})}
    >
      <div
        ref={textRef}
        className="work_ellipes"
        style={{
          maxWidth: MaxWidth,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: isOverflowing ? 'pointer' : 'default',
        }}
      >
        {Text}
      </div>

      {/* Custom Tooltip rendered in portal */}
      {isOverflowing &&
        isHovered &&
        ReactDOM.createPortal(
          <div
            className="custom-tooltip"
            style={{
              position: 'absolute',
              backgroundColor: '#323232',
              color: 'white',
              padding: '5px 10px',
              borderRadius: '4px',
              boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
              fontSize: '12px',
              whiteSpace: 'nowrap',
              top: tooltipPos.top,
              left: tooltipPos.left,
              zIndex: 9999,
              marginTop: '0px',
              pointerEvents: 'none',
            }}
          >
            {Text}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default WordWrapEllipse;
